import { HttpResponseStatusCodes } from '@hobt/constants';
import { ApiClient, ApiClientConfig } from 'Foundation/Api';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { config } from '../../../../../../config';
import { LoanInventoryTableFields } from '../components/HbtPortfolioLoansInventoryTable/types';
import { ApplicationPortfolioDetailPayload, LoanSummaryResponse } from './types';

type RequestProps = {
  authenticationContext: AuthenticationContextType;
  applicationID: string;
  portfolioIds: string;
};
const apiClientConfig: ApiClientConfig = {
  timeout: config.validationReviewInventoryApi.requestTimeout
};

const applicationDetailUrl: string = config.validationReviewInventoryApi.urls.applicationDetail;
const loansDetailsUrl: string = config.validationReviewInventoryApi.urls.loansDetails;

export const getApplicationDetail = async ({
  authenticationContext,
  applicationID,
  portfolioIds
}: RequestProps): Promise<ApplicationPortfolioDetailPayload | undefined> => {
  try {
    const requestQuery = `${applicationDetailUrl}/${applicationID}?portfolioIds=${portfolioIds}`;
    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      requestQuery
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data?.[0]) ||
      []
    );
  } catch (err) {
    // eslint-disable-next-line
    console.error('Error getting applications details:', err);
    throw new Error('Error getting applications details:', err!!);
  }
};

export const getLoansValidationDetails = async ({
  authenticationContext,
  applicationID,
  portfolioIds
}: RequestProps): Promise<LoanSummaryResponse | undefined> => {
  try {
    let requestQuery;
    requestQuery = `${loansDetailsUrl}/${applicationID}/loans/validation-details?portfolioIds=${portfolioIds}`;

    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      requestQuery
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data?.[0]) ||
      {}
    );
  } catch (err) {
    // eslint-disable-next-line
    console.error('Error getting loan validation details:', err);
    throw new Error('Error getting loan validation details:', err!!);
  }
};

type RequestPropsTableData = {
  authenticationContext: AuthenticationContextType;
  applicationID: string;
  portfolioIds: number[];
  queryParams: string;
};

const inventoryTimeout: number = config.validationReviewInventoryApi.requestTimeout;

export const getLoanInventoryTableData = async ({
  authenticationContext,
  applicationID,
  portfolioIds,
  queryParams
}: RequestPropsTableData): Promise<LoanInventoryTableFields[]> => {
  try {
    let requestQuery;
    requestQuery = `${loansDetailsUrl}/${applicationID}/loans/search${queryParams}`;

    const response = await ApiClient(authenticationContext, apiClientConfig).postWithAuth(
      requestQuery,
      { portfolioIds },
      { timeout: inventoryTimeout }
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    throw new Error('Error getting Loan inventory table data');
    // eslint-disable-next-line
    console.error('Error getting Loan inventory table data :', err);
    return [];
  }
};
